<template>
  <p class="number" v-if="number">Mesure n°{{ number }}</p>
  <p class="measure" title="Cliquez pour copier" @click="copyInClipboard">
    {{ measure }}
  </p>
  <input
    type="hidden"
    style="position: absolute; left: -9999px; top: -9999px"
    ref="measureInput"
    :value="measure"
  />
  <div class="actions">
    <div class="buttons">
      <button
        class="generate"
        :class="{ disabled: !choicesTypes.length }"
        title="Voir une nouvelle mesure"
        :disabled="!choicesTypes.length"
        @click="generateNewMeasure"
      >
        Voir une autre mesure
      </button>
      <button
        class="back"
        :class="{ disabled: !last.length }"
        title="Revenir à la précédente mesure"
        :disabled="!last.length"
        @click="back"
      >
        ⏎
      </button>
    </div>
    <div class="share">
      Partager sur {{ " " }}
      <twitter-button
        :description="description"
        btn-text=""
        @onShare="shareOnTwitter"
      />
      <facebook-button
        :description="description"
        btn-text=""
        @onShare="shareOnFacebook"
      />
    </div>
  </div>
</template>

<script>
import TwitterButton from "vue-share-buttons/src/components/TwitterButton";
import FacebookButton from "vue-share-buttons/src/components/FacebookButton";
import { analytics } from "../firebase.js";
import { logEvent } from "firebase/analytics";

export default {
  name: "MeasureGenerator",
  props: {
    choicesTypes: Array,
    choicesAttributes: Array,
    choicesProblems: Array,
  },
  components: {
    TwitterButton,
    FacebookButton,
  },
  data() {
    return {
      number: "",
      measure: "Chargement...",
      last: [],
      selfUrl: window.location,
    };
  },
  computed: {
    description() {
      return `${this.measure} #UnJourUneMesureMacron`;
    },
  },
  mounted() {
    this.generateNewMeasure();
  },
  methods: {
    random(max) {
      return (
        (Math.floor((Math.random() + Math.random() - Math.random()) * max) +
          max) %
        max
      );
    },
    generateNewMeasure() {
      if (
        !this.choicesTypes.length ||
        !this.choicesAttributes.length ||
        !this.choicesProblems.length
      )
        return;
      if (this.number) {
        this.last = [
          ...this.last,
          { number: this.number, measure: this.measure },
        ].slice(0, 100);
      }
      const randomTypes = this.random(this.choicesTypes.length);
      const randomAttributes = this.random(this.choicesAttributes.length);
      const randomProblems = this.random(this.choicesProblems.length);
      const text = [
        this.choicesTypes[randomTypes],
        this.choicesAttributes[randomAttributes],
        this.choicesProblems[randomProblems],
      ]
        .join(" ")
        .replace("  ", " ");
      this.number =
        randomTypes *
          this.choicesAttributes.length *
          this.choicesProblems.length +
        randomAttributes * this.choicesProblems.length +
        randomProblems;
      this.measure = text;
      logEvent(analytics, "screen_view", {
        firebase_screen: "Mesure",
        firebase_screen_class: "Mesure",
        text: this.measure,
      });
    },
    copyInClipboard() {
      try {
        this.$refs.measureInput.focus();
        this.$refs.measureInput.setAttribute("type", "text");
        this.$refs.measureInput.select();
        document.execCommand("copy");
        this.$refs.measureInput.setAttribute("type", "hidden");
        window.getSelection().removeAllRanges();
      } catch (e) {
        return;
      }
    },
    back() {
      if (!this.last.length) return;
      const last = this.last.pop();
      this.number = last.number;
      this.measure = last.measure;
    },
    shareOnTwitter() {
      logEvent(analytics, "share", {
        method: "Twitter",
        content_type: "text",
        item_id: this.measure,
      });
    },
    shareOnFacebook() {
      logEvent(analytics, "share", {
        method: "Facebook",
        content_type: "text",
        item_id: this.measure,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.number {
  color: #015fbd;
  font-size: 1.4em;
  font-weight: bold;
  text-transform: uppercase;
}
.measure {
  color: #000;
  cursor: pointer;
  font-size: 2.4em;
  padding: 15px 0;
}
.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
button {
  &.disabled,
  &.disabled:hover {
    cursor: not-allowed;
    opacity: 0.3;
  }
}
.buttons {
}
.generate {
  background: #015fbd;
  border: 0;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  flex: 1;
  font-size: 1.8em;
  text-transform: uppercase;
  padding: 1em 2em;
  &:hover {
    background: #064d93;
  }
}
.back {
  background: transparent;
  border: 0;
  border-radius: 4px;
  color: #999;
  cursor: pointer;
  flex: 0;
  font-size: 2.4em;
  margin-left: 5px;
  text-transform: uppercase;
  padding: 0.7em;
  &:hover {
    color: #3a3a3a;
  }
}
.share {
  align-items: center;
  display: flex;
  font-size: 1.4em;
  font-weight: bold;
  line-height: 3.4em;
  margin-left: 1em;
  text-align: right;
}
@media (max-width: 540px) {
  .actions,
  .buttons,
  .share {
    display: block;
    margin-top: 10px;
    margin-left: 0;
    width: 100%;
  }
}
</style>
